module.exports = __webpack_public_path__ + "static/media/1012558.331d3aa5.jpg";